import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { UserBehaviorService } from '../../services/user-events/user-behavior.service';
import { LocalStorageService } from '../../../app/connectors/localstorage';
import { MenuService } from '../../../app/services/menu.service';
import Swal from 'sweetalert2';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { TitleBarComponent } from '../../components/title-bar/title-bar.component';
import { RouterLink } from '@angular/router';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { NgIf, NgFor, JsonPipe } from '@angular/common';

@Component({
  selector: 'app-menu-config',
  templateUrl: './menu-config.component.html',
  styleUrls: ['./menu-config.component.css'],
  standalone: true,
  imports: [
    NgIf,
    LoaderOverlayComponent,
    BreadcrumbModule,
    RouterLink,
    TitleBarComponent,
    MatButtonModule,
    NgFor,
    FormsModule,
    JsonPipe
  ]
})
export class MenuConfigComponent implements OnInit, AfterViewInit, OnDestroy {
  email: any;
  profileUser: any;

  showSkeleton: boolean = true;
  showLoaderOverlay: boolean = true;
  hasAccess!: boolean;

  menuDataString: any;
  linesCount: any;
  menuBackupString: any;

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private userBehavior: UserBehaviorService,
    private serviceLocalStorage: LocalStorageService,
    private menuService: MenuService
  ) {
    const profile = this.serviceLocalStorage.decryptAndGet('profile');

    if (profile && profile.length > 0) {
      this.profileUser = profile[0];
    }

    this.userBehavior.selectedUser.pipe(takeUntil(this.destroy$)).subscribe((value: any) => (this.email = value.email));
  }

  ngOnInit(): void {
    this.getMenu();
  }

  ngAfterViewInit(): void {
    this.autoHeight();
  }

  getMenu(): any {
    this.menuService
      .getMenus()
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp) => {
        this.menuDataString = JSON.stringify(resp, null, 2);
        this.menuBackupString = JSON.stringify(resp, null, 2);

        this.totalLines(resp);
        this.showLoaderOverlay = false;
      });
  }

  totalLines(menu: any) {
    const jsonString = JSON.stringify(menu, null, 2);
    const lines = jsonString.split('\n');
    this.linesCount = Array(lines.length).fill(null);
  }

  detectChanges(event: any) {
    this.menuDataString = event.target.value;
    this.totalLines(this.menuDataString);
  }

  rollBackChanges() {
    this.menuDataString = this.menuBackupString;
  }

  saveData() {
    const jsonMenu = JSON.parse(this.menuDataString);
    this.menuService.setMenu(jsonMenu).subscribe((resp) => {
      if (resp === 'OK') {
        this.getMenu();
      }
    });

    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Your work has been saved',
      showConfirmButton: false,
      timer: 2000
    });
  }

  autoHeight() {
    document.addEventListener('DOMContentLoaded', () => {
      const container = document.querySelectorAll<HTMLElement>('.editor-lineNumber')! as any;
      var area = document.getElementById('txtEditor');

      if (container.length) {
        container.forEach((size: any) => {
          setTimeout(() => {
            var total = size.querySelector('ul');
            var gridHeight = total.offsetHeight;

            if (area) {
              area.style.setProperty('height', gridHeight + 'px', 'important');
            }
          }, 300);
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$?.complete();
  }
}
